import React from 'react';

const Vue_Quiz = () => {
  return (
    <div>
      <h1>Vue_Quiz Component</h1>
      <p>This is the Vue_Quiz tutorial page.</p>
    </div>
  );
}

export default Vue_Quiz;
